import { httpClient, postProcessDelete } from "@genai/http-client";
import { CollectionId } from "../model";

export function deleteCollection(collectionId: CollectionId) {
  return  httpClient(`/collections/${collectionId}`, {
    method: "DELETE",
  }).then(postProcessDelete);
}
